import { render, staticRenderFns } from "./AssistantQa.vue?vue&type=template&id=36fd9a09"
import script from "./AssistantQa.vue?vue&type=script&lang=js"
export * from "./AssistantQa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports